/**
 * System checkTools Store
 *
 * @since 2018-03-12
 * @author devp010
 */

export const state = () => ({
  integrityDataList: [],
  axiosNoShowLoadingOpt: {
    loading: false,
    loadingHide: true,
    successAlert: false
  }
})

export const mutations = {
  setIntegrityDataList (state, payload) {
    if (payload != null && payload.length > 0) {
      state.integrityDataList = Object.freeze(payload)
    }
  },
  // reset
  resetIntegrityDataList (state) {
    state.integrityDataList = []
  }
}

export const actions = {
  async reqActionSystemIntegrityTool ({commit, state}) {
    try {
      const apiUrl = `/api/sm/tools/inetegrity`
      const res = await this.$axios.$get(apiUrl, state.axiosNoShowLoadingOpt)
      if (res.code === 'ok') {
        commit('setIntegrityDataList', res.result)
      }
      return res
    } catch (e) {
      return {
        code: 'nok',
        result: {
          msg: e
        }
      }
    }
  }
}

export const getters = {}

export const strict = false
